export const ORGANIZATION_KEYS = {
  all: () => ["organization"] as const,
  tpas: () => [...ORGANIZATION_KEYS.all(), "tpas"] as const,
  carriers: () => [...ORGANIZATION_KEYS.all(), "carriers"] as const,
};
